import { useCallback } from "react";

import { SCROLL_REVIEW_LOGS_DRAWER_TO_TOP_EVENT } from "../ReviewLogsDrawerControls/constants";

import { useStructuredSearchRefresh } from "@/components/StructuredSearch/hooks/useStructuredSearchRefresh";

interface UseSidebarStructuredSearchRefreshOptions {
  onRefresh?: () => void;
  clearNewDataBadge: () => void;
  resetSidebarQuery: () => void;
}

export const useSidebarStructuredSearchRefresh = ({
  onRefresh,
  clearNewDataBadge,
  resetSidebarQuery,
}: UseSidebarStructuredSearchRefreshOptions) => {
  const { advanceStructuredEndIfNeeded } = useStructuredSearchRefresh();

  return useCallback(() => {
    onRefresh?.();

    const shouldAdvanceEnd = advanceStructuredEndIfNeeded();

    window.dispatchEvent(new Event(SCROLL_REVIEW_LOGS_DRAWER_TO_TOP_EVENT));

    clearNewDataBadge();

    if (shouldAdvanceEnd) {
      return;
    }

    resetSidebarQuery();
  }, [advanceStructuredEndIfNeeded, clearNewDataBadge, onRefresh, resetSidebarQuery]);
};
